import Vue from 'vue'
import Router from 'vue-router'
import routes from '@routes'
import store from '@store'
import * as types from '@store/types'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.name === 'Login') return next()
  if (from.name === 'Home') store.commit(types.SCROLL_POSITION, 0)

  const { token: hasToken, expiresAt } = store.getters[types.AUTH]

  const generic_flag = await store.getters[types.FLAG_GENERIC_APP]
  const { generic_app } = await store.getters[types.CONFIG_MAIN]

  const isLogged = (Date.now() < expiresAt) && hasToken
  const { path } = to

  if (!isLogged && !to.meta.unauthenticated && !generic_app && !generic_flag) {
    try {
      next({ name: 'Entrar', query: { redirectTo: to.fullPath } })
    }
    catch(err) {
      console.log('navigation error:', err)
    }

    const text = 'Você precisa estar logado para acessar outras paginas'

    return path !== '/' && store.dispatch(types.FEEDBACK, { type: 'error', text })
  } else if (!isLogged && !to.meta.unauthenticated && generic_app) {
    return window.location.href = process.env.GENERIC_LOGOUT_URL + '/entrar'
  } else if (!isLogged && !to.meta.unauthenticated && generic_flag) {
    return window.location.href = process.env.GENERIC_LOGOUT_URL + '/entrar?logout=true'
  } else if (isLogged && to.meta.unauthenticated) {
    return next({ name: 'Home' })
  }

  store.dispatch(types.BREADCRUMB_ROUTES, to)

  next()
})

router.afterEach((to, from, next) => {
  window.scroll({ top: 0, left: 0, behavior: 'smooth' })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js